/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LocatorTableListAliases {
  CONTEXTUAL_BAR = 'contextual-bar',
  FETCH = 'fetch',
  FILTER = 'filter',
  FILTERED_LIST = 'filtered-list',
  GLOBAL_ACTIONS = 'global-actions',
  ID_TABLE_COLUMN = 'id-table-column',
  LAYOUT_0 = 'layout-0',
  NAME_FIELD = 'name-field',
  NAME_INPUT = 'name-input',
  NAME_TABLE_COLUMN = 'name-table-column',
  PAGINATOR_LOCATOR_TABLE_LIST = 'paginator-locator-table-list',
  SELECT_BUTTON = 'select-button',
  TABLE = 'table',
}
export { LocatorTableListAliases };
